// Components
import React from 'react';

// Styles
import { useStyles } from './ErrorMessageStyles';

const ErrorMessage = ({ message }) => {
  const { classes } = useStyles();

  return <p className={classes.message}>{message}</p>;
};

export default ErrorMessage;
